import { render, staticRenderFns } from "./SensorsTable.vue?vue&type=template&id=631461b4"
import script from "./SensorsTable.vue?vue&type=script&lang=js"
export * from "./SensorsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports